import axios from "axios";
var baseDomain = process.env.VUE_APP_ROOT_API;
var baseURL = `${baseDomain}`; // Incase of /api/v1;

// ALL DEFUALT CONFIGURATION HERE

export default axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    // "Authorization": "Bearer xxxxx"
  }
});
